import {Icon, iconsMap} from '../../../common/icons/icon.comp';
import {BaseWidgetProps} from '../../widget-container';
import {WidgetKbModuleSettings} from '@wix/answers-api';
import * as React from 'react';
import { WidgetMessage, WidgetMessageType } from '../../../common/message-types';
import { sanitizeExceptWidgetSdk } from '@wix/answers-widget-viewer';

export type KbHeroProps = {
	searchTerm: string,
	baseWidgetProps: BaseWidgetProps,
	moduleSettings: WidgetKbModuleSettings,
	onSearchChange: (searchTerm: string, prevSearchTerm: string) => void
	onSearchFocusChanged: (isSearchFocused: boolean) => void
};

export type KbHeroState = {
	searchTerm: string;
	isCategoryListOpen: boolean,
	isSearchFocus: boolean;
	customHtml?: string;
};

export class KbHero extends React.Component<KbHeroProps, any> {

	state: KbHeroState = {
		searchTerm: '',
		isCategoryListOpen: false,
		isSearchFocus: false,
		customHtml: this.props.baseWidgetProps.messageHistory.getCustomHeroHtml()
			? sanitizeExceptWidgetSdk(this.props.baseWidgetProps.messageHistory.getCustomHeroHtml() || '')
			: ''
	};

	searchDebounceTimer: any = null;
	searchDebounceBiTimer: any = null;
	searchDebounceDelay = 500;
	searchDebounceBiDelay = 1500;

	constructor (props: KbHeroProps) {
		super(props);
	}

	componentDidMount () {
		if (this.props.searchTerm) {
			this.setState({searchTerm: this.props.searchTerm});
		}

		if (window) {
			window.addEventListener('message', this.handlePostMessage);
		}
	}

	componentWillReceiveProps (nextProps: KbHeroProps) {
		if (this.props.searchTerm !== nextProps.searchTerm) {
			this.setState({searchTerm: nextProps.searchTerm || ''});
		}
	}

	handlePostMessage = (event: MessageEvent) => {
		const widgetMessage: WidgetMessage = event.data.__ansWidget;
		if (widgetMessage) {
			switch (widgetMessage.type) {
				case WidgetMessageType.SET_CUSTOM_HERO_HTML:
					const cleanHtml = sanitizeExceptWidgetSdk(widgetMessage.data.heroHtml);
					this.setState({customHtml: cleanHtml});
					break;
				default:
					break;
			}
		}
	}

	handleSearchDebounced (prevSearchTerm: string) {
		clearTimeout(this.searchDebounceTimer);
		this.searchDebounceTimer = setTimeout(() => {
			this.props.onSearchChange(this.state.searchTerm, prevSearchTerm);
		}, this.searchDebounceDelay);
	}

	onSearchChange (newSearchTerm: string) {
		if (this.state.searchTerm !== newSearchTerm) {
			const prevSearchTerm = this.state.searchTerm;
			this.setState({ searchTerm: newSearchTerm }, () => {
				this.handleSearchDebounced(prevSearchTerm);
			});
		}
	}

	setSearchFocus (isFocused: boolean) {
		this.props.baseWidgetProps.widgetNavigator.setSearchFocus(isFocused,
			this.props.baseWidgetProps.logger.logEvent);
		this.setState({isSearchFocus: isFocused});
		this.props.onSearchFocusChanged(isFocused);
	}

	render () {
		const isKbHomepage = this.props.baseWidgetProps.widgetNavigator.isKbHomepage();
		const moduleSettings = this.props.moduleSettings;
		const translate = this.props.baseWidgetProps.translate;
		const onSearchChange = (e: any) => this.onSearchChange(e.target.value);
		const title = moduleSettings.title || translate('widget-ng.hero.default-title');
		const searchboxText = moduleSettings.searchboxText || translate('widget-ng.hero.search-placeholder');
		const mainTitleComp = <h1 className='main-title'>{title}</h1>;
		const heroClassName = (isKbHomepage && moduleSettings.subTitle) ?
																	'hero has-sub' :
																	'hero';
		const mainSubTitleComp = <h2 className={'sub-title'}>{moduleSettings.subTitle}</h2>;
		const searchBoxClass = `search-box${this.state.isSearchFocus || this.state.searchTerm ? ' focus' : ''}`;
		const searchComp = moduleSettings.searchEnabled ?
		(
			<div className={searchBoxClass}>
				<div className='search-placeholder'>
					<Icon className='search-magnifier' icon={iconsMap.magnifier} />
					<span className='placeholder-text'>{searchboxText}</span>
				</div>
				<input
					type='text'
					id='search'
					value={this.state.searchTerm}
					onChange={onSearchChange}
					onBlur={() => this.setSearchFocus(false)}
					onFocus={() => this.setSearchFocus(true)}
				/>
			</div>
		) : null;

		const customComponent = this.state.customHtml ?
			<div className='custom-component-container' dangerouslySetInnerHTML={{__html: this.state.customHtml}}/> : null;

		return (
			<div className={heroClassName}>
				{mainTitleComp}
				{customComponent}
				{mainSubTitleComp}
				{searchComp}
			</div>
		);
	}
}
